import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


import Cropper from 'cropperjs';
window.Cropper = Cropper;


import '@wotz/livewire-sortablejs/src/';


import Chart from 'chart.js/auto';
window.Chart = Chart;


import flatpickr from "flatpickr";
window.flatpickr = flatpickr;


import Hls from 'hls.js'
window.Hls = Hls;
